import { SearchResultItem } from './search-result-item'
import type { SearchEntityType, SearchResult } from '../types/search.types'

interface SearchResultGroupProps {
  type: SearchEntityType
  results: SearchResult[]
  selectedIndex: number
  baseIndex: number
  onSelect: (result: SearchResult) => void
}

const groupLabels: Record<SearchEntityType, string> = {
  client: 'Clients',
  engagement: 'Engagements',
  task: 'Tasks',
  document: 'Documents',
}

export function SearchResultGroup({
  type,
  results,
  selectedIndex,
  baseIndex,
  onSelect
}: SearchResultGroupProps) {
  if (results.length === 0) return null

  return (
    <div className="search-result-group">
      <div className="search-group-header">
        {groupLabels[type]} <span className="search-group-count">({results.length})</span>
      </div>
      {results.map((result, idx) => (
        <SearchResultItem
          key={result.id}
          result={result}
          isSelected={selectedIndex === baseIndex + idx}
          onClick={() => onSelect(result)}
        />
      ))}
    </div>
  )
}
